module.exports = __webpack_public_path__ + "static/media/cartagena-30.ab5ffc4d.jpg";